<template>
  <a-space class="filter-space">
    <a-select ref="select" v-model:value="sortType" style="width: 120px" @change="handleChangeSort">
      <a-select-option value="priceUp">按价格升序</a-select-option>
      <a-select-option value="priceDown">按价格降序</a-select-option>
    </a-select>
    <a-checkbox-group v-model:value="params" @change="changeFilter">
      <a-checkbox v-for="item in list" :key="item.label" :value="item.value">
        {{ item.label }}
      </a-checkbox>
    </a-checkbox-group>
  </a-space>
</template>
<script>
export default {
  data() {
    return {
      sortType: "priceUp",
      params: [],
      list: [
        { label: "24小时发货", value: "shipIn24Hours" },
        { label: "48小时发货", value: "shipIn48Hours" },
        { label: "7天无理由退货", value: "noReason7DReturn" },
        { label: "一件代发包邮", value: "isOnePsaleFreePost" },
      ],
    };
  },
  methods: {
    handleChangeSort() {
      this.$emit("change-sort", this.sortType);
    },
    changeFilter() {
      const params = this.params?.length ? this.params.join(",") : "";
      localStorage.setItem("pdd_xf_shanghuo_1688_soutu_filters", params);
      this.$emit("change-filter", params);
    },
  },
  mounted() {
    const data = localStorage.getItem("pdd_xf_shanghuo_1688_soutu_filters");
    this.params = data ? data.split(",") : [];
  },
};
</script>
<style scoped lang="less">
.filter-space {
  .ant-checkbox-group {
    :deep(.ant-checkbox-wrapper) {
      font-size: 15px;
      .ant-checkbox-checked {
        + span {
          color: #007fff;
        }
      }
    }
  }
}
</style>
